export enum EntityListCacheKeys {
  PAY_PERIODS = 'time-card-pay-periods',
  EMPLOYEE_STATUS_TYPE = 'time-card-employee-status-types',
  STATUS_TYPES_LIST = 'time-card-status-types-list',
  HOURS_SUMMARY_FORMAT = 'time-card-hours-summary-format',
  EMPLOYEE_GROUPING_DISPLAY_ORDER_TEXT = 'time-card-employee-grouping-display-order-text',
  EMPLOYEE_LICENSE_TYPE = 'employee-license-type',
  PAY_TYPES = 'pay-types',
  PAY_PERIOD_GROUPS = 'pay-period-groups',
}

export enum UserCacheKeys {
  EMPLOYEES_GROUPING_LABOR_LEVELS = 'time-card-employee-grouping-labor-level',
  EMPLOYEES_FILTER_SETTINGS = 'time-card-employee-filter-settings',
  USER_PREFERENCES = 'time-card-user-preferences',
  FULL_NAME_DISPLAY_ORDER = 'time-card-full-name-display-order',
  EMPLOYEE_INFO_TEXT = 'time-card-employee-info-text',
  EMPLOYEE_TIME_CARD_SETTINGS = 'time-card-employee-time-card-settings',
  RECENTLY_VIEWED_EMPLOYEES = 'time-card-recently-viewed-employees',
}

export enum FacilityCacheKeys {
  LICENSE = 'time-card-license',
}

export enum ScheduleCacheKeys {
  EMPLOYEE_SCHEDULES = 'time-card-employee-schedules',
  EMPLOYEE_PLACEHOLDERS = 'time-card-employee-placeholders',
  EMPLOYEE_SCHEDULE_CONFIGURATION = 'time-card-employee-schedule-configuration',
  EMPLOYEE_SCHEDULE_AUDIT = 'time-card-employee-schedule-audit',
  EMPLOYEE_PLACEHOLDER_AUDIT = 'time-card-employee-placeholder-audit',
}

export enum ConfigurationCacheKeys {
  OTHER_HOUR_DEFAULT_VALUES = 'time-card-other-hour-default-values',
}
